import his from './his';
import { VendorConfig } from './types';

const vendors: Record<string, VendorConfig> = {
  his,
};

export default vendors;
